import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { PrivatePage } from 'src/components/auth';
import DashboardLayout from 'src/components/dashboardLayout';
import { APP_ROUTES } from 'src/enums';
import { ErSummaryScreen } from 'src/screens/erSummary';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IErSummaryProps {}

const ErSummaryPage: React.FunctionComponent<IErSummaryProps> = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('screens.erSummary')}</title>
      </Helmet>
      <PrivatePage>
        <DashboardLayout
          activeRoute={APP_ROUTES.ER_SUMMARY}
          subTitle={t('screens.erSummary')}
        >
          <ErSummaryScreen />
        </DashboardLayout>
      </PrivatePage>
    </>
  );
};

export default ErSummaryPage;
